import React from 'react'
import PropTypes from 'prop-types'

import {
  digObject, deepSetObject, matchFilterArrayIncludes, toggleArray,
} from '@domain-group/javascript-utils'

import {
  Box, Checkbox, ListItem, Form,
} from '@domain-group/suit-theme'

const handleCheckPage = (requiredPages, serviceProductForm, title) => {
  const { entityState: { options }, setEntityState } = serviceProductForm

  const updatedRequiredPages = toggleArray(requiredPages, title)
  const updatedOptions = deepSetObject(options, 'artwork.required_pages', updatedRequiredPages)

  setEntityState({ options: updatedOptions })
}

const renderTemplatePageComponents = (serviceProductForm) => {
  const { entityState } = serviceProductForm

  const { artwork, template } = digObject(entityState, 'options', {})

  if (template && template.pages){
    const requiredPages = digObject(artwork, 'required_pages', [])

    return template.pages.map((page) => {
      const { title } = page
      const checked = !!matchFilterArrayIncludes(requiredPages, title)

      return (
        <ListItem.WithCheckbox
          boxProps={{ border: 'none' }}
          checkbox={(
            <Checkbox
              checked={checked}
              fontSize="small"
              onClick={() => handleCheckPage(requiredPages, serviceProductForm, title)}
            />
          )}
          disableHover
          key={title}
        >
          <Box color="bodyFontLightColor" fontSize="xsmall">
            {title}
          </Box>
        </ListItem.WithCheckbox>
      )
    })
  }

  return null
}

const ArtworkRequiredPages = (props) => {
  const { serviceProductForm } = props

  return (
    <Form.Field boxProps={{ width: '50%' }} label="Required Pages" marginTop="large">
      <Form.Row>
        {renderTemplatePageComponents(serviceProductForm)}
      </Form.Row>
    </Form.Field>
  )
}

ArtworkRequiredPages.propTypes = {
  serviceProductForm: PropTypes.object.isRequired,
}

export default ArtworkRequiredPages
